export default "__VITE_ASSET__ed56fef3__"